export default __webpack_public_path__ + "static/media/PlayStoreIco.11bd9bfe.svg";